// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__kFbZy","checkboxCol":"Table_checkboxCol__2Q5tQ","emailCol":"Table_emailCol__38xQN","actionCol":"Table_actionCol__Vczzd"};